import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newPaltzConfig } from "./data";

export default function NewPaltzPage() {
  return <CityPageTemplate config={newPaltzConfig} />;
}